import { action, makeAutoObservable, observable } from 'mobx';
import { gameLiveConnection } from '../gameLiveConnection/gameLiveConnection';
import { timerDuration } from '../../core/constants/gameConstants';
import { soundService } from '../services/SoundService';
import { roundInfoStore } from '@pascal/pascal-core/shared/core/store';


class GameStore {
  resultReportState = false;
  doSpinState = false;
  isGamePadDisabled = false
  matrixType = 1;
  demoRoundId = 0;
  time = timerDuration
  amount = 0;
  odds = {}
  quickBets = []
  chosenField = null;


  constructor() {
    makeAutoObservable(this, {
      resultReportState: observable,
      doSpinState: observable,
      isGamePadDisabled: observable,
      amount: observable,
      demoRoundId: observable,
      time: observable,
      quickBets: observable,
      odds: observable,
      chosenField: observable,
      currencyCode: observable,
      currencySymbol: observable,
      setMatrixType: action.bound,
      setState: action.bound,
      setAmount: action.bound,
      setDoSpinState: action.bound,
      setResultReportState: action.bound,
      setOdds: action.bound,
      setTime: action.bound,
      setAmountByIndex: action.bound,
      setChosenField: action.bound,
      setIsGamePadDisabled: action.bound,
    });
  }

  setResultReportState(resultReportState) {
    this.resultReportState = resultReportState;
  }

  setDoSpinState(doSpinState) {
    this.doSpinState = doSpinState;
  }

  setTime(time) {
    this.time = time;
  }

  setOdds(odds) {
    this.odds = odds;
  }

  setIsGamePadDisabled(value) {
    this.isGamePadDisabled = value;
  }

  startTimer() {
    this.clearTimeInterval();
    this.__timeInterval = setInterval(() => {
      if(this.time > 0) {
        return this.setTime(this.time - 1)
      }
      this.clearTimeInterval();
      gameStore.setIsGamePadDisabled(true)
      gameLiveConnection.sendCashOut()
    },1000)
  }

  clearTimeInterval() {
    if (gameStore.__timeInterval) {
      soundService.stopTimer()
      clearInterval(gameStore.__timeInterval);
      gameStore.__timeInterval = null;
    }
  }

  setAmountByIndex(index) {
    this.amount = this.quickBets[index];
  }

  setAmount(amount) {
    this.amount = amount
  }

  upgradeDemoSpinId() {
    this.demoRoundId += 1
  }

  setMatrixType(matrixType) {
    this.matrixType = matrixType;
  }

  setChosenField(fieldIndex) {
    this.chosenField = fieldIndex;
  }

  setQuickBets(quickBets) {
    this.quickBets = quickBets.reverse();
  }

  resetResults() {
    gameStore.setResultReportState(false)
    gameStore.setIsGamePadDisabled(false)
    roundInfoStore.setRoundId(null)
  }

}

export const gameStore = new GameStore();